/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddTaskReportCommandResult } from '../../models/add-task-report-command-result';

export interface ApiTaskAddTaskReportPut$Params {
      body?: {
'Id'?: string;
'Report'?: string;
'Attachments'?: Array<Blob>;
}
}

export function apiTaskAddTaskReportPut(http: HttpClient, rootUrl: string, params?: ApiTaskAddTaskReportPut$Params, context?: HttpContext): Observable<StrictHttpResponse<AddTaskReportCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskAddTaskReportPut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddTaskReportCommandResult>;
    })
  );
}

apiTaskAddTaskReportPut.PATH = '/api/Task/AddTaskReport';
